const GET_RECENT_ATTACHMENTS = 'GET_RECENT_ATTACHMENTS'

const UPLOAD_ATTACHMENT = 'UPLOAD_ATTACHMENT'
const UPLOAD_ATTACHMENT_SUCCESS = 'UPLOAD_ATTACHMENT_SUCCESS'
const UPLOAD_ATTACHMENT_ERROR = 'UPLOAD_ATTACHMENT_ERROR'

const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'
const DELETE_ATTACHMENT_SUCCESS = 'DELETE_ATTACHMENT_SUCCESS'
const DELETE_ATTACHMENT_ERROR = 'DELETE_ATTACHMENT_ERROR'

const GENERATE_OUTLINE = 'GENERATE_OUTLINE'
const GENERATE_OUTLINE_SUCCESS = 'GENERATE_OUTLINE_SUCCESS'
const GENERATE_OUTLINE_ERROR = 'GENERATE_OUTLINE_ERROR'

const GENERATE_COURSE = 'GENERATE_COURSE'
const GENERATE_COURSE_SUCCESS = 'GENERATE_COURSE_SUCCESS'
const GENERATE_COURSE_ERROR = 'GENERATE_COURSE_ERROR'

const UPDATE_OUTLINE = 'UPDATE_OUTLINE'
const UPDATE_OUTLINE_SUCCESS = 'UPDATE_OUTLINE_SUCCESS'
const UPDATE_OUTLINE_ERROR = 'UPDATE_OUTLINE_ERROR'

const CHECK_ATTACHMENT_STATUS_AI_CREATOR = 'CHECK_ATTACHMENT_STATUS_AI_CREATOR'
const CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR =
  'CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR'
const CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR =
  'CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR'

const GET_DOCUMENT_HEADERS = 'GET_DOCUMENT_HEADERS'
const GET_DOCUMENT_HEADERS_SUCCESS = 'GET_DOCUMENT_HEADERS_SUCCESS'
const GET_DOCUMENT_HEADERS_ERROR = 'GET_DOCUMENT_HEADERS_ERROR'

const GET_ATTACHMENT_TITLES = 'GET_ATTACHMENT_TITLES'
const GET_ATTACHMENT_TITLES_SUCCESS = 'GET_ATTACHMENT_TITLES_SUCCESS'
const GET_ATTACHMENT_TITLES_ERROR = 'GET_ATTACHMENT_TITLES_ERROR'

export {
  UPLOAD_ATTACHMENT,
  UPLOAD_ATTACHMENT_SUCCESS,
  UPLOAD_ATTACHMENT_ERROR,
  DELETE_ATTACHMENT,
  DELETE_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_ERROR,
  UPDATE_OUTLINE,
  UPDATE_OUTLINE_SUCCESS,
  UPDATE_OUTLINE_ERROR,
  CHECK_ATTACHMENT_STATUS_AI_CREATOR,
  CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR,
  CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR,
  GENERATE_OUTLINE,
  GENERATE_OUTLINE_SUCCESS,
  GENERATE_OUTLINE_ERROR,
  GENERATE_COURSE,
  GENERATE_COURSE_ERROR,
  GENERATE_COURSE_SUCCESS,
  GET_RECENT_ATTACHMENTS,
  GET_DOCUMENT_HEADERS,
  GET_DOCUMENT_HEADERS_SUCCESS,
  GET_DOCUMENT_HEADERS_ERROR,
  GET_ATTACHMENT_TITLES,
  GET_ATTACHMENT_TITLES_SUCCESS,
  GET_ATTACHMENT_TITLES_ERROR,
}
